
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { StoryUser } from '../StoryUser';
import { CloudinaryResult } from '../Cloudinary';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import * as utils_cloudinary from '../utils_cloudinary';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src
import AvatarComponent from '@/components/AvatarComponent.vue';           // @ is an alias to /src
import { globalUC } from '../UserCache';

interface Link {
  name: string
  path: string
}

@Component({
  name: 'NavbarComponent',
  components: { 
    ModalWrapperComponent: () => import('@/components/ModalWrapperComponent.vue'),
    AvatarComponent }
})
export default class NavbarComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public links: Link[] = []

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get inTutorial(): boolean { return this.$store.state.inTutorial; }
  public get profilePicMenuText(): string { return this.user.profilePic ? 'Change profile picture' : 'Add profile picture' }
  public get phoneNumberMenuText(): string { return this.user.phoneNumberIds.length === 0 ? 'Add phone number' : 'Change phone number' }
  public get numInvites(): number { return this.user.getCircle().pendingIncomingFollowers.length }
  public get userRegisteredWithFacebook(): boolean { return this.user.fbAuthResponse !== null }

  public optimizeForFacebook(): boolean { return this.$fb.isLoggedIntoStoryCircleViaFacebook || (this.$fb.useFbLoginRandomAB && process.env.VUE_APP_FB_LOGIN === 'true' && this.$fb.isLoggedIntoFacebook && localStorage.getItem('utm_source') === 'facebook') }

  public userChoseSettings(): void {}   // TODO
  public async userChoseSignOut() { 
    await utils_auth.logout()
  }
  public userChoseLogin(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (this.$refs.LoginFormModalComponent as ModalWrapperComponent).show(null, 'sm', null)
  }
  public userChoseRegister(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (this.$refs.RegisterFormModalComponent as ModalWrapperComponent).show('Sign Up', 'sm', null)
  }
  public userChoseFacebookLogin(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (window as any).analytics.track('User ClickedFBLogin')
    this.$fb.login()
  }
  public async userChoseChangeProfilePicture(): Promise<void> {
    await utils_cloudinary.uploadPhoto(this, utils_cloudinary.photoType.profilePic, null, null, (result: CloudinaryResult) => { this.$router.go(0); }, null, null)
  }
  public userChosePhoneNumber(): void {
    const title: string = this.user.phoneNumberIds.length === 0 ? 'Add a Phone Number to Your Account' : 'Change Phone Number';
    (this.$refs.PhoneNumberFormModalComponent as ModalWrapperComponent).show(title, 'md', null)
  }
  public userChoseMyCircle(): void {
    (this.$refs.UserCircleModalComponent as ModalWrapperComponent).show(`${this.user.firstName}'s Listening Circle`, 'sm', { startingUid: this.userId, startingUser: this.user, enableInviting: true } )
  }
  public userChoseInvites(): void {
    (this.$refs.RespondToInvites as ModalWrapperComponent).show(`Invitations to Join Your Circle`, 'md', null)
  }
  public async userChoseChangePassword() {
    // make POST call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/auth/forgotPassword'
      const response: any = await utils.makePostCall(url, { usernameOrEmail: this.user.email } );
      if (!response || !response.data) throw(new Error('userChoseChangePassword() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
      }
      if (response.data.user) {
        // success
        this.$store.commit('setLoading', { loading: false });
        this.$emit('close', true)

        const user: StoryUser = new StoryUser(response.data.user)
        user.updateMeToCacheStoreAndLocalStorage()

        utils.toast(this, 'Success', 'Check your email for a link to resetting your password.')
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not process')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }
  }

  // private, non-reactive member variables
  private tab: string = null
  private cloudinaryWidget: any = null

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    this.doTabs()
    this.tab = this.$route.path.split('/')[1]

    // utils.setCurrentTab(this.tab)
    if (this.$store.state.devmode) console.log(`navbar.pathChanged() ${this.$route.path} => this.tab: ${this.tab}`)
  }

  private async mounted(): Promise<void> {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    this.doTabs();

    // the user cache may have a later version of our user than our store (e.g. profile pic), so update it
    if (this.userId) {
      const userFromCache: StoryUser = await globalUC.get(this.userId, true)
      if (userFromCache) utils_auth.saveAuthStuffToStoreAndLocalStorage(userFromCache, null)
    }
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

  // private functions not available directly to HTML template
  private doTabs(): void {
    this.links = []
    // this.links.push({ name: 'Home', path: '/home' })
    // this.links.push({ name: 'History', path: '/history' })
    // console.log(this.links)
  }

}
